import { Mail, Globe, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { Logo } from "./ui";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const legal = [
    { label: f.links.privacy, to: "/privacy", testid: "privacy" },
    { label: f.links.terms, to: "/terms", testid: "terms" },
    { label: f.links.disclosure, to: "/payment-disclosure", testid: "payment-processing" },
    { label: f.links.contact, href: "/#contact", testid: "contact" },
  ];
  return (
    <footer data-testid="site-footer" className="bg-navy-950 text-white/70">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-5 text-white/60 leading-relaxed max-w-sm">{f.tagline}</p>
          <p className="mt-5 text-sm text-white/40">{f.operated}</p>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-display text-lg font-semibold text-white">{f.getInTouch}</h4>
          <ul className="mt-5 space-y-3 text-[15px]">
            <li className="flex items-center gap-3">
              <Mail size={18} className="text-gold-400" />
              <a href="mailto:hello@konekchurch.com" className="hover:text-white transition-colors" data-testid="footer-email">
                hello@konekchurch.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Globe size={18} className="text-gold-400" />
              <span>www.konekchurch.com</span>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={18} className="text-gold-400" />
              <span>South Florida</span>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-lg font-semibold text-white">{f.legal}</h4>
          <ul className="mt-5 space-y-3 text-[15px]">
            {legal.map((l) => (
              <li key={l.testid}>
                {l.to ? (
                  <Link to={l.to} className="hover:text-white transition-colors" data-testid={`footer-link-${l.testid}`}>
                    {l.label}
                  </Link>
                ) : (
                  <a href={l.href} className="hover:text-white transition-colors" data-testid={`footer-link-${l.testid}`}>
                    {l.label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/40">
          <p>© {new Date().getFullYear()} Konek Church. {f.rights}</p>
          <p className="max-w-xl text-center sm:text-right">{f.note}</p>
        </div>
      </div>
    </footer>
  );
};
